import { CopyToClipboard } from '@/modules/copy-to-clipboard';

if (document.querySelector('.js-copy-to-clipboard')) {
    new CopyToClipboard(document.querySelector('.js-copy-to-clipboard'));
}
